import React from 'react';
import {
  EndMobileStockLocationSessionResponse,
  EndMobileStockLocationSessionVariables,
  MobileStockLocationMutations,
} from '../../../../../graphql/mobileStockLocation.graphql';
import useMutation from '../../../../../hooks/useMutation';
import { useToast } from '../../../../../providers/ToastProvider';
import { TranslationKey } from '../../../../../types/translation/TranslationKey';
import { t } from '../../../../../types/translation/Translator';
import { Button, ButtonVariant, CancelButton } from '../../../../components/Button';
import { AlertModal } from '../../../../components/Modal';
import { ToastType } from '../../../../components/Toast';

interface EndMobileStockLocationSessionModalProps {
  open: boolean;
  setOpen: (open: boolean) => void;
  sessionId: string;
}

export default function EndMobileStockLocationSessionModal({
  sessionId,
  open,
  setOpen,
}: EndMobileStockLocationSessionModalProps) {
  const { showToast } = useToast();

  const [endSession, { loading }] = useMutation<
    EndMobileStockLocationSessionResponse,
    EndMobileStockLocationSessionVariables
  >(MobileStockLocationMutations.end, {
    variables: { sessionId },
    onCompleted: () => {
      showToast({
        type: ToastType.success,
        title: t(TranslationKey.endMobileStockLocationSessionSuccessfullyToastTitle).singular.upper,
      });
      setOpen(false);
    },
  });

  return (
    <AlertModal
      open={open}
      setOpen={setOpen}
      title={t(TranslationKey.endMobileStockLocationSessionModalTitle).singular.upper}
    >
      <div className='grid gap-4'>
        <p className='subtitle'>{t(TranslationKey.endMobileStockLocationSessionModalSubtitle).singular.upper}</p>
        <div className='flex justify-end gap-2'>
          <CancelButton onClick={() => setOpen(false)} disabled={loading} />
          <Button
            variant={ButtonVariant.danger}
            text={t(TranslationKey.endSession).singular.upper}
            onClick={() => endSession()}
            loading={loading}
          />
        </div>
      </div>
    </AlertModal>
  );
}
